import React from 'react'
import {
  Row,
  Col,
  TextDisplay,
  Button,
  HeadingText,
} from '@paypalcorp/pp-react'
import { useApplicationContext } from '../../../context/ApplicationContext'

import { Message, injectWorldReady } from '@paypalcorp/worldready-react'
import { getUpgradeBusinessAccountURL } from '../../../utils/app-utils'
import { getUserType } from '../../../utils/user-utils'
function UpgradeAccount({ setIsCredsForClient }) {
  const { user } = useApplicationContext()
  const accountType = getUserType(user)

  return (
    <>
      <Row>
        <Col xs={12} className="banner-title_row">
          <HeadingText size="sm">
            <Message id="onboarding-banner.livePaymentsTitle" />
          </HeadingText>
        </Col>
      </Row>
      <Row className="live-payment_row_non_business">
        <Col className="live-payment_col_2">
          <TextDisplay
            name="live-non-business-title-1"
            valueClassName="live-non-business-payment_font"
            label=""
            value={<Message id="onboarding-banner.liveNonBusinessTitle1" />}
            helperText={
              <Message id="onboarding-banner.liveNonBusinessHelperText1" />
            }
          />
        </Col>
        <Col className="live-payment_col_2">
          <TextDisplay
            name="live-non-business-title-2"
            valueClassName="live-non-business-payment_font"
            label=""
            value={<Message id="onboarding-banner.liveNonBusinessTitle2" />}
            helperText={
              <Message id="onboarding-banner.liveNonBusinessHelperText2" />
            }
          />
        </Col>
      </Row>
      <br />
      <Row>
        <Col
          style={{ padding: '0px 0px 0px 10px' }}
          className="live-payment_col_2"
        >
          <Button
            as="a"
            href={getUpgradeBusinessAccountURL({ accountType })}
            role="button"
            target="_blank"
            rel="noreferrer"
            size="md"
          >
            <Message id="onboarding-banner.liveNonBusinessButton1" />
          </Button>
        </Col>
        <Col
          style={{ padding: '0px 0px 0px 10px' }}
          className="live-payment_col_2"
        >
          <Button size="md" secondary onClick={() => setIsCredsForClient(true)}>
            <Message id="onboarding-banner.liveNonBusinessButton2" />
          </Button>
        </Col>
      </Row>
    </>
  )
}

export default injectWorldReady(UpgradeAccount)
